import { useEffect, useState } from 'react';
import { FieldConfig } from '../../../../../components/CustomFormsComponents/CustomField';
import { TEST_IDS } from '../testIds';
import { useAppSelector } from '../../../../../hooks/reduxHooks';

const useNewStudyFieldsConfig = ({ t, newStudyFormData, handleBlurValidation }: any) => {
    const [newStudyFieldsConfig, setNewStudyFieldsConfig] = useState<FieldConfig[]>([]);
    const carcinogenicParametricData = useAppSelector(
        (state) => state.carcinogenicReport.carcinogenicParametricData
    );
    
    useEffect(() => {
        const newStudyFieldsConfig: FieldConfig[] = [
            {
                type: 'autocomplete',
                label: t('newStudyForm.inputs.type') as string,
                name: 'type',
                required: true,
                value: newStudyFormData.type,
                disabled: false,
                helperText: t('newStudyForm.inputs.type') as string,
                onBlurValidation: handleBlurValidation,
                inputType: 'number',
                options: carcinogenicParametricData?.tiposEstudio,
                getOptionLabel: (item) => `${item?.descripcion}`,
                gridSpace: { xs: 12 },
                testID: TEST_IDS.newStudyFields.type,
                validations: [{ name: 'required' }, { name: 'maxLength', param: 150 }]
            },
            {
                type: 'text',
                label: t('newStudyForm.inputs.detail') as string,
                name: 'detail',
                required: true,
                value: newStudyFormData.detail,
                disabled: false,
                helperText: t('newStudyForm.inputs.detail') as string,
                onBlurValidation: handleBlurValidation,
                gridSpace: { xs: 12 },
                testID: TEST_IDS.newStudyFields.detail,
                validations: [{ name: 'required' }]
            },
            {
                type: 'autocomplete',
                label: t('newStudyForm.inputs.frequency') as string,
                name: 'frequency',
                required: true,
                value: newStudyFormData.frequency,
                disabled: false,
                helperText: t('newStudyForm.inputs.frequency') as string,
                onBlurValidation: handleBlurValidation,
                inputType: 'number',
                options: carcinogenicParametricData?.tiposFrecuencia,
                getOptionLabel: (item) => `${item?.descripcion}`,
                gridSpace: { xs: 12 },
                testID: TEST_IDS.newStudyFields.frequency,
                validations: [{ name: 'required' }, { name: 'maxLength', param: 50 }]
            },
            {
                type: 'text',
                label: t('newStudyForm.inputs.frequencyQuantity') as string,
                name: 'frequencyQuantity',
                required: true,
                value: newStudyFormData.frequencyQuantity,
                disabled: false,
                helperText: t('newStudyForm.inputs.frequencyQuantity') as string,
                onBlurValidation: handleBlurValidation,
                inputType: 'number',
                gridSpace: { xs: 12 },
                testID: TEST_IDS.newStudyFields.frequencyQuantity,
                validations: [
                    { name: 'required' },
                    { name: 'maxLength', param: 50 },
                    { name: 'minValue', param: 0 }
                ]
            }
        ];

        setNewStudyFieldsConfig(newStudyFieldsConfig);
    }, []);

    return { newStudyFieldsConfig };
};

export default useNewStudyFieldsConfig;
